export default "/assets/images/white-filter.webp?2f5790aba03e005e2793460e565258d5";